if(!customElements.get('product-comparison')) {
  class ProductComparison extends HTMLElement {
    constructor() {
      super();

      this.elRowHeadings = this.querySelectorAll('[data-row-heading]');
      this.elColumns = this.querySelectorAll('[data-column]');
      this.elRows = this.querySelectorAll('[data-row]');
      
      this.setRowHeights();
      window.addEventListener('resize', () => this.setRowHeights());
    }

    setRowHeights() {
      const getLongestInnerHtml = (arr) => arr.sort((a, b) => b.innerHTML.length - a.innerHTML.length)[0];

      this.elRowHeadings.forEach((elHeading, rowIndex) => {
        const elRows = [...this.elColumns].map(el => {
          const elColumnRows = el.querySelectorAll('[data-row]');
          return [...elColumnRows].find((el, index) => index == rowIndex);
        });
        
        const heading = JSON.parse(elHeading.getAttribute('data-row-heading'));
        const elLongestRow = getLongestInnerHtml(elRows);
        const longestRowContent = elLongestRow ? JSON.parse(elLongestRow.getAttribute('data-content')) : `${heading}`;
        
        elHeading.innerHTML = `
          ${heading}
          <div class="placeholder" aria-hidden="true" role="presentation">
            ${longestRowContent}
          </div>
        `;
        
        elRows.forEach((elRow, index) => {
          const elColumn = this.elColumns[index];
          if(elRow) {
            elRow.innerHTML = `
              <div class="product-comparison--row-content">
                <div class="product-comparison--row-heading">${heading}</div>
                ${JSON.parse(elRow.getAttribute('data-content'))}
              </div>
              <div class="placeholder" aria-hidden="true" role="presentation">
                <div class="product-comparison--row-heading">${heading}</div>
                ${longestRowContent}
              </div>
            `
          } else if(elColumn) {
            elColumn.innerHTML = `
              ${elColumn.innerHTML}
              <td class="product-comparison--row small" data-row="text" data-content="">
                <div class="product-comparison--row-heading">${heading}</div>
                <div class="placeholder" aria-hidden="true" role="presentation">
                  <div class="product-comparison--row-heading">${heading}</div>
                  <div>${longestRowContent}</div>
                </div>
              </div>
            `
          }
        })
      })
    }
  }
  customElements.define('product-comparison', ProductComparison);
}